<div class="header-filter-analytics">
  <!-- Search bar for the graph library -->
  @if (showGraphLibrary) {
    <div class="search-container">
      <div class="search-bar">
        <span>
          <svg-icon class="search-icon" [name]="'magnifying-glass'"></svg-icon>
        </span>
        <input
          type="text"
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchChanged($event)"
          [placeholder]="'analytics.searchGraphPlaceholder' | translate"
          class="search-input"
        />
        @if (searchTerm) {
          <div class="clear-button-wrapper" (click)="clearSearch()">
            <svg-icon class="clear-button" [name]="'close'"></svg-icon>
          </div>
        }
      </div>
    </div>
  }

  <!-- Button to navigate back to the graph library -->
  @if (isGraphSelected) {
    <app-button
      (clicked)="navigateToLibrary()"
      iconLeft="arrow-left"
      color="grey"
      [rounded]="true"
    ></app-button>
  }

  <!--
    The filters of the selected chart. Which ones those are is the chart's own
    declaration (IGraphFrontConfig), read through analyticsConfigFor; what each
    one looks like is a row of the `controls` table. One slot per kind of control.
  -->
  @for (control of shownControls; track control.paramKey) {
    @switch (control.kind) {
      @case ("checkbox") {
        <app-filter-button
          [type]="'checkbox'"
          [label]="control.label"
          [icon]="control.icon"
          [maxItems]="control.maxItems?.()"
          [dataOverride]="control.options?.()"
          [checkedData]="control.checked()"
          [showAllVariant]="!!control.showAllVariant"
          (manageList)="control.emit($event)"
        ></app-filter-button>
      }
      @case ("radio") {
        <app-filter-button
          [type]="'radio'"
          [label]="control.label"
          [icon]="control.icon"
          [radioData]="control.radioOptions()"
          [defaultRadioValue]="control.radioValue()"
          [isEmpty]="!control.radioOptions().length"
          [pathTranslate]="control.pathTranslate"
          (manageList)="control.emit($event)"
        ></app-filter-button>
      }
      @case ("dateRange") {
        <app-filter-button
          [type]="'dateRange'"
          [label]="control.label"
          [icon]="control.icon"
          [dateRangeData]="filterDates"
          [isEmpty]="!filterDates.length"
          (manageList)="control.emit($event)"
        ></app-filter-button>
      }
      @case ("number") {
        <app-searchbar-number
          [label]="control.label"
          [icon]="control.icon"
          [inputData]="filterDays?.toString() ?? ''"
          [inputActive]="!!filterDays"
          (number)="control.emit($event)"
        ></app-searchbar-number>
      }
    }
  }
</div>
